import React, { useState, useEffect } from 'react';

const HomeBanner = ({ videos, bannerText, onGoToShop }) => {
  const safeVideos = Array.isArray(videos) ? videos : [];
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [fade, setFade] = useState(false); // <--- estado fade

  useEffect(() => {
    const videoElement = document.getElementById('banner-video');
    if (videoElement) {
      videoElement.load();
      videoElement.play().catch(error => console.log("Autoplay prevented:", error));
    }
  }, [currentVideoIndex, safeVideos]); // Usa safeVideos

  const handleVideoEnd = () => {
    setFade(true); // Activa el fade out
    setTimeout(() => {
      setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % safeVideos.length);
      setFade(false); // Fade in para el siguiente video
    }, 400); // Duración del fade en ms (puedes ajustar)
  };

if (!safeVideos.length || !bannerText.title) return null;

  return (
    <section className="relative w-full h-72 sm:h-96 md:h-[480px] lg:h-[600px] overflow-hidden shadow-2xl">
      <video
        id="banner-video"
        className={`absolute top-0 left-0 w-full h-full object-cover pointer-events-none transition-opacity duration-500 ${fade ? 'opacity-0' : 'opacity-100'}`}
        src={safeVideos[currentVideoIndex]}
        onEnded={handleVideoEnd}
        muted
        autoPlay
        playsInline
      />
      <div className="absolute inset-0 bg-black bg-opacity-50 sm:bg-opacity-30 flex flex-col justify-center items-center text-white p-4 transition-all duration-500">
        <h1 className="text-2xl sm:text-4xl lg:text-6xl font-display font-extrabold text-center mb-3 sm:mb-4 drop-shadow-lg">
          {bannerText.title}
        </h1>
        <p className="text-base sm:text-lg lg:text-2xl text-center max-w-2xl drop-shadow-lg mb-4 sm:mb-8">
          {bannerText.description}
        </p>
        <button
          onClick={onGoToShop}
          className="bg-primary hover:bg-buttonHover text-white font-semibold px-8 py-3 rounded-xl text-lg sm:text-xl shadow-xl transition-all"
        >
          {bannerText.buttonText}
        </button>
      </div>
    </section>
  );
};

export default HomeBanner;
